module.exports = __webpack_public_path__ + "img/teamImg15.4e9dd645.jpg";